import api from "@/libs/axios";
import * as ep from "../../endpoints";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { hasError } from "@/utils/utils";
function mapNewsFormData(form) {
  var fd = new FormData();
  for (const key in form) {
    if (Object.hasOwnProperty.call(form, key)) {
      const element = form[key];
      if (key === "slides") {
        element.forEach((element) => {
          fd.append("slides[]", element);
        });
      } else fd.append(key, element);
    }
  }
  return fd;
}
export default {
  namespaced: true,
  state: {
    news: [],
    loading: false,
    working: false,
    loadingDetails: false,
    pagination: {},
    detailsNews: {},
  },
  getters: {
    news(state) {
      return state.news;
    },
    detailsNews(state) {
      return state.detailsNews;
    },
    loadingDetails(state) {
      return state.loadingDetails;
    },
    loading(state) {
      return state.loading;
    },
    pagination(state) {
      return state.pagination;
    },
    loadingSubmit(state) {
      return state.loadingSubmit;
    },
    loadingDelete(state) {
      return state.loadingDelete;
    },
    working(state) {
      return state.working;
    },
  },
  mutations: {
    setNews(state, payloade) {
      state.news = payloade;
    },
    setPagination(state, payloade) {
      state.pagination = payloade;
    },
    setDetailsNews(state, payloade) {
      state.detailsNews = payloade;
    },
    setLoading(state, val) {
      state.loading = val;
    },
    setWorking(state, val) {
      state.working = val;
    },
  },
  actions: {
    async getNews(context, payloade) {
      context.state.loading = true;
      await api
        .get(ep.NEWS, { params: { page: payloade.page } })
        .then((res) => {
          context.state.detailsNews = {};
          context.commit("setNews", res.data.data);
          context.commit("setPagination", res.data.pagination);
          context.state.loading = false;
        });
    },

    async getDetailsNews(context, payloade) {
      context.state.loadingDetails = true;
      await api.get(ep.DETAILSNEWS(payloade.id)).then((res) => {
        context.commit("setDetailsNews", res.data.data);
      });
      context.state.loadingDetails = false;
    },
    async updateNews({ commit, dispatch }, payload) {
      commit("setLoading", true);
      try {
        const res = await api.post(ep.DETAILSNEWS(payload.id), payload.fd);
        if (hasError(res.status)) {
          throw res.status;
        }
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تم التعديل بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
        dispatch("getDetailsNews", { id: payload.id_news });

        return Promise.resolve();
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تعديل البيانات",
            icon: "AlertCircleIcon",
            variant: "danger",
            timeout: 3000,
          },
        });
        return Promise.reject();
      } finally {
        commit("setLoading", false);
      }
    },
    async createNews({ commit }, payload) {
      commit("setWorking", true);
      try {
        var fd = mapNewsFormData(payload);
        const res = await api.post(ep.NEWS, fd);

        if (hasError(res.status)) {
          throw res.status;
        }
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تمت الإضافة بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
        return Promise.resolve();
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء إضافة البيانات",
            icon: "AlertCircleIcon",
            variant: "danger",
            timeout: 3000,
          },
        });
        return Promise.reject();
      } finally {
        commit("setWorking", false);
      }
    },
    async deleteNews({ commit }, payload) {
      commit("setLoading", true);
      try {
        const res = await api.delete(ep.DETAILSNEWS(payload.id));

        if (hasError(res.status)) {
          throw res.status;
        }
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تم الحذف بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
        return Promise.resolve();
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تعديل البيانات",
            icon: "AlertCircleIcon",
            variant: "danger",
            timeout: 3000,
          },
        });
        return Promise.reject();
      } finally {
        commit("setLoading", false);
      }
    },
  },
};
